import { render, staticRenderFns } from "./PreferredPlan.vue?vue&type=template&id=5559987c"
import script from "./PreferredPlan.vue?vue&type=script&lang=js"
export * from "./PreferredPlan.vue?vue&type=script&lang=js"
import style0 from "./PreferredPlan.vue?vue&type=style&index=0&id=5559987c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports